var render = function render(){var _vm=this,_c=_vm._self._c;return _c('default-sidebar',{attrs:{"active":_vm.$store.state.sidebars.showPropertyCreateForm}},[(_vm.$store.state.sidebars.showPropertyCreateForm)?_c('property-create-form'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }